// extracted by mini-css-extract-plugin
module.exports = {"container":"SwipeCard_container__3dbOT","card":"SwipeCard_card__-aGWg"};